import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=5fc4d15e&scoped=true"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=5fc4d15e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4d15e",
  null
  
)

export default component.exports